import styled from 'styled-components';
import { AccordionItemMixin } from '../../mixins/components/AccordionItemMixin';
export var StyledAccordionItem = /*#__PURE__*/styled.li.withConfig({
  displayName: "StyledAccordionItem",
  componentId: "c11n-8-111-1__sc-10xpf1n-0"
})(["", ""], AccordionItemMixin);